import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store' // для хука beforeEach, beforeEnter или beforeRouteEnter

import ServerIsNotAvailable from '@/components/CommonPages/ServerIsNotAvailable'
import PageNotFound from '@/components/CommonPages/404PageNotFound'
import PageForbidden from '@/components/CommonPages/403PageForbidden'

import Welcome from '@/components/Welcome/Welcome'
import SignIn from '@/components/Welcome/SignIn'
import SignUp from '@/components/Welcome/SignUp'
import ForgotPassword from '@/components/Welcome/ForgotPassword'

import MainLayout from '@/components/MainLayout'

import UserProfile from '@/components/UserProfile'
import User from '@/components/User'

import Events from '@/components/Events'
import Event from '@/components/Event'
import EventEdit from '@/components/EventEdit'

import Places from '@/components/Places'
import Place from '@/components/Place'
import PlaceEdit from '@/components/PlaceEdit'

import http from 'axios'

// const SearchResults = resolve => {
  // require.ensure(['@/components/Main/SearchResults'], () => {
    // resolve(require('@/components/Main/SearchResults'))
  // }, 'pack1')
// }

// component: (resolve) => require(['./views/index.vue'], resolve)
// const SearchResults = resolve => {
//   require(['@/components/Main/SearchResults'], resolve)
// }

Vue.use(Router)

const router = new Router({
  mode: 'history', // 'history' mode - don't see a hash '#' in urls
  routes: [
    // ////////////////////////////////////////////////////////////////////////////////////////////////////

    {
      path: '/serverisnotavailable',
      component: ServerIsNotAvailable
    },

    // ////////////////////////////////////////////////////////////////////////////////////////////////////

    {
      path: '/welcome',
      component: Welcome,
      beforeEnter (to, from, next) {
        // если уже авторизованы то идем в основное меню
        if (store.getters.activeUser !== null) {
          next('/')
        } else {
          next()
        }
      },
      children: [
        {
          path: '',
          component: SignIn
        },
        {
          path: 'signup',
          component: SignUp
        },
        {
          path: 'forgotpassword',
          component: ForgotPassword
        }
      ]
    },

    // ////////////////////////////////////////////////////////////////////////////////////////////////////

    {
      path: '/',
      component: MainLayout,
      beforeEnter (to, from, next) {
        store.commit('appStateLastWorkingRouteSet', to.path)
        // в MainLayout можно попасть только если авторизован. КРОМЕ просмотреа списка эвентов и эвента
        // console.log(to.path)
        // сейчас пока и эту логику убрал. приложение само показывает куда можно а куда нет через обработку меню в зависимости от залогиненности и группы пользователя
        // потому что часто страница доступна но только с укороченными данными. а другие страницы если недоступны то могут быть недоступны даже после авторизации
        // не всем группам пользователей и переводит на 403PageForbidden. или это все тут в роутере делать или на страницах. пока там на страницах
        // if ((to.path !== '/') && (to.path !== 'event') && (store.getters.activeUser === null)) {
        //   next('/welcome')
        // } else {
        //  next()
        // }
        next()
      },
      children: [
        {
          path: '',
          component: Events
        },
        {
          path: 'event/:id',
          name: 'event',
          component: Event,
          props: true
        },
        {
          path: 'event-edit/:id',
          name: 'event-edit',
          component: EventEdit,
          props: true
        },
        {
          path: 'event-edit',
          name: 'event-edit-new',
          component: EventEdit
        },
        {
          path: 'places',
          component: Places
        },
        {
          path: 'place/:id',
          name: 'place',
          component: Place,
          props: true
        },
        {
          path: 'place-edit/:id',
          name: 'place-edit',
          component: PlaceEdit,
          props: true
        },
        {
          path: 'place-edit',
          name: 'place-edit-new',
          component: PlaceEdit
        },
        {
          path: 'user/:id',
          name: 'user',
          component: User,
          props: true
        },
        {
          path: 'profile',
          component: UserProfile
        },
        {
          path: 'pageForbidden',
          component: PageForbidden
        },
        {
          path: '*',
          component: PageNotFound
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  document.title = store.getters.appSettings.appName

  // Google-аналитика
  if (store.getters.appSettings.useGoogleAnalytics === true) {
    setTimeout(function () {
      window.dataLayer = window.dataLayer || []
      function gtag () { window.dataLayer.push(arguments) }
      gtag('js', new Date())
      gtag('config', 'G-PSF16JHVMP')
    }, 1)
  }

  // сохраняем если кто-то перешел сюда по ссылке от конкретного пользователя. потом при user signup возьмем это значение
  // если пользователь снова пришел в приложение но по новой ссылке то invBy обновится и пользователь создаться по новому свежему приглашению
  if (to.query.inv != null) localStorage.setItem('invitedByUser', to.query.inv)

  if (store.getters.appSettings.server.host == null) {
    store.commit('serverHostSet', 'VSEZDES')
  }

  if (to.path === '/serverisnotavailable') {
    return next()
  }

  // если пользователь установлен то сразу выходим ибо дальше пытаемся установить пользователя
  if (store.getters.activeUser !== null) {
    return next()
  }
  // иначе устанавливаем пользователя в приложении, беря его с сервера
  http.get(store.getters.appSettings.server.userGetActiveUser) // вызов вовзращает с сервера activeUser object ИЛИ 403 (Forbidden)
  .then(function (response) {
    // let BMSClient2017ActiveUser = JSON.parse(localStorage.BMSClient2017ActiveUser)
    // localStorage.setItem('BMSClient2017ActiveUser', JSON.stringify(response.data)) // перезаписываем localStorage на случай если на сервере изменились детали activeUser
    store.commit('activeUserSet', response.data)
    // TODO: проверка пермишенов
    return next()
  })
  .catch(function (error) {
    // если сервер вернул 403 значит пользователь не залогинен
    if ((error.response != null) && (error.response.status === 403)) {
      // ничего не делаем, специфика каждого роутера сама разберется что делать если пользователь все так же не установлен
      return next()
    } else {
      return next('/serverisnotavailable')
    }
  })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js